export const CASHBACK_TYPE = {
  TO_PAY: 'TO_PAY',
  NOT_APPROVED: 'NOT_APPROVED',
  REJECT: 'REJECT',
  TOTAL: 'TOTAL',
  CHARGE: 'CHARGE',
};
